var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    opacity: 0,
    stroke: "none",
    d: " M61.000000,101.000000  C40.666672,101.000000 20.833340,101.000000 1.000008,101.000000  C1.000005,67.666679 1.000005,34.333351 1.000003,1.000021  C34.333317,1.000014 67.666634,1.000014 100.999969,1.000007  C100.999977,34.333313 100.999977,67.666626 100.999985,100.999969  C87.833336,101.000000 74.666664,101.000000 61.000000,101.000000  M33.524670,17.000000  C30.753506,17.000000 27.982342,17.000000 25.279064,17.000000  C25.279064,39.962730 25.279064,62.365120 25.279064,84.717926  C31.966700,84.717926 38.372017,84.717926 44.718460,84.717926  C44.718460,62.032303 44.718460,39.629879 44.718460,17.000000  C41.129566,17.000000 37.820057,17.000000 33.524670,17.000000  M77.000000,72.489014  C77.000000,54.063202 77.000000,35.637390 77.000000,17.290548  C70.015038,17.290548 63.608986,17.290548 57.288891,17.290548  C57.288891,39.984047 57.288891,62.385845 57.288891,84.708412  C63.987286,84.708412 70.392014,84.708412 77.000000,84.708412  C77.000000,80.773346 77.000000,77.128120 77.000000,72.489014  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M34.017609,17.000000  C37.820057,17.000000 41.129566,17.000000 44.718460,17.000000  C44.718460,39.629879 44.718460,62.032303 44.718460,84.717926  C38.372017,84.717926 31.966700,84.717926 25.279064,84.717926  C25.279064,62.365120 25.279064,39.962730 25.279064,17.000000  C27.982342,17.000000 30.753506,17.000000 34.017609,17.000000  z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M77.000000,72.985962  C77.000000,77.128120 77.000000,80.773346 77.000000,84.708412  C70.392014,84.708412 63.987286,84.708412 57.288891,84.708412  C57.288891,62.385845 57.288891,39.984047 57.288891,17.290548  C63.608986,17.290548 70.015038,17.290548 77.000000,17.290548  C77.000000,35.637390 77.000000,54.063202 77.000000,72.985962  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.4ac042e0074a886c067de015905567f9.svg";
export { ForwardRef as ReactComponent };